export const de = {
  "auth.signIn": "Anmelden",
  "auth.signOut": "Abmelden",
  "auth.label": "Mitglieder",
  "auth.title": "Melden Sie sich an, um die Fahrzeuge zu sehen",
  "auth.sub": "Aktueller Bestand aus Korea und Japan, mit dem Preis frei Haus in Ihrem Land. E-Mail eingeben, wir schicken einen Link — kein Passwort, das Sie sich ausdenken oder merken müssen.",
  "auth.send": "Link schicken",
  "auth.sending": "Wird gesendet…",
  "auth.why": "Ihre Adresse nutzen wir für den Link und für die Antwort auf Ihre Anfragen. Für nichts anderes, und niemals für Dritte.",
  "auth.sentLabel": "Sehen Sie in Ihr Postfach",
  "auth.sentTitle": "Der Link ist unterwegs",
  "auth.sentBody": "Wir haben einen Anmeldelink an {email} geschickt. Öffnen Sie ihn auf diesem Gerät, und Sie sind drin.",
  "auth.sentSpam": "Er sollte innerhalb einer Minute ankommen. Sonst im Spam-Ordner nachsehen — und die eingegebene Adresse prüfen.",
  "auth.useAnother": "Andere Adresse verwenden",
  "auth.alreadyIn": "Sie sind angemeldet",
  "auth.err.invalid_email": "Das sieht nicht nach einer E-Mail-Adresse aus.",
  "auth.err.too_many": "Zu viele Link-Anfragen. Warten Sie ein paar Minuten.",
  "auth.err.mail_failed": "Die E-Mail konnte gerade nicht gesendet werden. Bitte gleich nochmals versuchen.",
  "auth.err.link_expired": "Dieser Link ist abgelaufen oder wurde bereits benutzt. Hier ist ein neuer.",
  "nav.stock": "Fahrzeugbestand",
  "nav.auctions": "Japan-Auktionen",
  "nav.calculator": "Importrechner",
  "nav.how": "Ablauf",
  "nav.contact": "Kontakt",
  "common.from": "ab",
  "common.to": "bis",
  "common.any": "Beliebig",
  "common.all": "Alle",
  "common.loading": "Wird geladen…",
  "common.showMore": "Mehr anzeigen",
  "common.showLess": "Weniger anzeigen",
  "common.reset": "Zurücksetzen",
  "common.close": "Schliessen",
  "common.back": "Zurück",
  "common.km": "km",
  "common.year": "Jahr",
  "common.results": "{n} Fahrzeuge",
  "common.noResults": "Keine Fahrzeuge für diese Filter",
  "common.noResultsBody": "Erweitern Sie die Preis- oder Jahrgangsspanne oder entfernen Sie einen Filter.",
  "common.estimate": "Schätzung",
  "common.optional": "optional",
  "common.required": "erforderlich",
  "common.error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "common.retry": "Erneut versuchen",
  "home.eyebrow": "Korea · Japan → Europa",
  "home.title": "Die Autos, die Europa nie bekam.",
  "home.sub": "Sport- und Luxuswagen aus Korea und Japan, bis vor Ihre Haustür geliefert. Zielland: {country}. Einfuhrzoll, Mehrwertsteuer und Homologation sind in jedem angezeigten Preis enthalten.",
  "home.cta": "Fahrzeugbestand ansehen",
  "home.cta2": "Importkosten schätzen",
  "home.stat.cars": "inserierte Fahrzeuge",
  "home.stat.makes": "Marken",
  "home.stat.markets": "Herkunftsmärkte",
  "home.why.title": "Warum Korea und Japan",
  "home.why.kr.title": "Korea fährt Linkslenker",
  "home.why.kr.body": "In Korea herrscht Rechtsverkehr. Jedes koreanische Auto ist daher ein Linkslenker und lässt sich in Frankreich, der Schweiz, Deutschland und Luxemburg ohne Lenkradumbau fahren. Ein grosser, kaufkräftiger Markt, auf dem Autos intensiv gefahren werden und den europäische Käufer kaum sehen.",
  "home.why.jp.title": "Japan hält seine Autos in Schuss",
  "home.why.jp.body": "Fahrzeuge aus Japan sind für geringe Laufleistungen und sorgfältige Pflege bekannt. Das Bewertungssystem der Auktionen macht ihren Zustand vor dem Gebot nachvollziehbar. Wir bieten ausschliesslich Linkslenker an: europäische Exoten, die in Japan als Neuwagen verkauft wurden.",
  "home.why.price.title": "Ein Preis, keine versteckten Kosten",
  "home.why.price.body": "Jedes Fahrzeug zeigt die Kosten bis vor Ihre Haustür: Kauf, Export, Seefracht, Einfuhrzoll, Mehrwertsteuer, Homologation und Zulassung. Kein Lockpreis mit Überraschungen am Hafen.",
  "home.featured": "Aktuell im Bestand",
  "home.featuredAll": "Gesamten Bestand ansehen",
  "stock.title": "Fahrzeugbestand",
  "stock.sub": "Aktueller Bestand aus Korea und Japan. Die angezeigten Preise sind geschätzte Endpreise inklusive Lieferung. Zielland: {country}.",
  "stock.filters": "Filter",
  "stock.sort": "Sortieren",
  "stock.sort.newest": "Neueste Inserate zuerst",
  "stock.sort.price_asc": "Endpreis geliefert: aufsteigend",
  "stock.sort.price_desc": "Endpreis geliefert: absteigend",
  "stock.sort.year_desc": "Jahrgang: neueste zuerst",
  "stock.sort.mileage_asc": "Laufleistung: niedrigste zuerst",
  "stock.search": "Marke, Modell suchen…",
  "stock.f.make": "Marke",
  "stock.f.model": "Modell",
  "stock.f.source": "Markt",
  "stock.f.price": "Endpreis geliefert",
  "stock.f.year": "Jahr",
  "stock.f.mileage": "Maximale Laufleistung",
  "stock.f.fuel": "Treibstoff",
  "stock.f.body": "Karosserie",
  "stock.f.transmission": "Getriebe",
  "stock.f.steering": "Lenkradposition",
  "stock.f.photos": "Nur mit Fotos",
  "stock.f.search": "Suchen",
  "stock.f.noMatch": "Kein Treffer",
  "stock.steering.LHD": "Linkslenker",
  "stock.steering.RHD": "Rechtslenker",
  "stock.steering.any": "Beliebig",
  "stock.clearAll": "Alle zurücksetzen",
  "car.landedIn": "Endpreis geliefert — {country}",
  "car.estimateNote": "Geschätzter Gesamtpreis. Die Spanne berücksichtigt Positionen, die wir je Fahrzeug individuell offerieren.",
  "car.listedAt": "Inseriert im Markt {market} für",
  "car.compare": "Länder vergleichen",
  "car.compareNote": "Dasselbe Fahrzeug, vier Zielländer. Steuern und Homologation unterscheiden sich deutlich.",
  "car.cheapest": "Günstigstes Zielland",
  "car.breakdown": "So setzt sich der Preis zusammen",
  "car.leadTime": "Geschätzte Lieferfrist",
  "car.leadTimeDays": "{n} Tage",
  "car.enquire": "Dieses Fahrzeug anfragen",
  "car.enquireSub": "Wir bestätigen den genauen Betrag, prüfen das Fahrzeug und kümmern uns um alles bis zur Lieferung vor Ihre Haustür.",
  "car.specs": "Technische Daten",
  "car.spec.year": "Jahr",
  "car.spec.mileage": "Laufleistung",
  "car.spec.fuel": "Treibstoff",
  "car.spec.transmission": "Getriebe",
  "car.spec.engine": "Motor",
  "car.spec.body": "Karosserie",
  "car.spec.colour": "Farbe",
  "car.spec.steering": "Lenkradposition",
  "car.spec.seats": "Sitzplätze",
  "car.spec.location": "Standort",
  "car.spec.seller": "Verkäufer",
  "car.advisory": "Mögliche Zusatzarbeiten",
  "car.advisoryNote": "Nicht im obigen Preis enthalten. Fast nichts davon trifft auf ein einzelnes Fahrzeug zu — was die Prüfung ergibt, wird vor einer Zusage separat offeriert.",
  "car.advisoryUpTo": "bis zu {amount}, falls alles nötig wäre",
  "car.priceOnRequest": "Preis auf Anfrage",
  "car.priceOnRequestBody": "Dieses Fahrzeug ist ohne öffentlichen Preis inseriert. Wir holen ihn ein und offerieren den vollständigen Endpreis.",
  "car.daysOnMarket": "Seit {n} Tagen am Markt",
  "car.daysOnMarketHelp": "Wie lange dieses Fahrzeug in seinem Heimatmarkt bereits inseriert ist. Ein Fahrzeug, das seit Monaten steht, ist meist verhandelbar.",
  "car.demoLot": "Beispiel-Los",
  "car.demoLotNote": "Ein Demonstrationslos, kein kaufbares Fahrzeug. Die Live-Auktionsdaten sind noch nicht angebunden — die Zahlen zeigen, wie ein echtes Los kalkuliert würde.",

  // fuel
  "spec.fuel.petrol": "Benzin",
  "spec.fuel.diesel": "Diesel",
  "spec.fuel.electric": "Elektro",
  "spec.fuel.hybrid": "Hybrid",
  "spec.fuel.petrol-hybrid": "Benzin-Hybrid",
  "spec.fuel.diesel-hybrid": "Diesel-Hybrid",
  "spec.fuel.petrol-lpg": "Benzin / Autogas",
  "spec.fuel.lpg": "Autogas",
  "spec.fuel.hydrogen": "Wasserstoff",

  // transmission
  "spec.transmission.automatic": "Automatik",
  "spec.transmission.manual": "Schaltgetriebe",
  "spec.transmission.semi-automatic": "Halbautomatik",
  "spec.transmission.cvt": "CVT",
  "spec.transmission.dct": "DCT",

  // body
  "spec.body.suv": "SUV",
  "spec.body.sports-car": "Sportwagen",
  "spec.body.saloon": "Limousine",
  "spec.body.coupe": "Coupé",
  "spec.body.convertible": "Cabriolet",
  "spec.body.estate": "Kombi",
  "spec.body.hatchback": "Schrägheck",
  "spec.body.mpv": "Van",
  "spec.body.van": "Transporter",
  "spec.body.truck": "Lkw",
  "spec.body.city-car": "Kleinstwagen",
  "spec.body.small-car": "Kleinwagen",
  "spec.body.compact": "Kompaktklasse",
  "spec.body.mid-size": "Mittelklasse",
  "spec.body.full-size": "Oberklasse",

  // seller
  "spec.seller.dealer": "Händler",
  "spec.seller.private": "Privatperson",
  "spec.seller.auction": "Auktion",
  "car.similar": "Ähnliche Fahrzeuge",
  "car.assumptions": "Unsere Annahmen",
  "car.assumptionsNote": "Diese Angaben werden von der Quelle nicht veröffentlicht. Wir bestätigen jede einzelne, bevor wir eine verbindliche Offerte erstellen. Sie können den Gesamtbetrag verändern.",
  "car.required": "Erforderlich",
  "car.quotedPerCar": "Pro Fahrzeug offeriert",
  "car.import.hard": "Schwierig zuzulassen in {country}",
  "car.import.hardTitle": "Schwierig zuzulassen in {country}",
  "car.import.hardBody": "Dieses Fahrzeug ist importierbar, die Zulassung ist aber kein Routinefall und wird von uns einzeln kalkuliert. Sprechen Sie mit uns, bevor Sie sich festlegen.",
  "car.import.noTitle": "Nicht importierbar nach {country}",
  "car.import.noBody": "Diese Marke lässt sich in {country} nicht als Privatimport zulassen. Das Fahrzeug wird noch angezeigt, weil Sie einem Link gefolgt sind — wechseln Sie oben das Land, dort ist es womöglich verfügbar.",
  "car.import.lightsTitle": "Japanisches Fahrzeug — Scheinwerfer müssen getauscht werden",
  "car.import.lightsBody": "In Japan herrscht Linksverkehr, die Scheinwerfer sind entsprechend eingestellt und müssen bei jedem Fahrzeug von dort ersetzt werden. Die Marke spielt keine Rolle. Wir offerieren die Arbeit pro Fahrzeug.",
  "car.gone": "Nicht mehr verfügbar",
  "car.goneBody": "Dieses Fahrzeug ist nicht mehr auf dem Markt. Sagen Sie uns, was Sie gesucht haben. Wir finden ein anderes.",
  "car.freight": "Verschiffungsart",
  "car.freight.roro": "RoRo (am günstigsten)",
  "car.freight.container_shared": "Sammelcontainer",
  "car.freight.container_exclusive": "Exklusiver Container",
  "car.coc": "Der Hersteller kann eine EU-Übereinstimmungsbescheinigung (COC) ausstellen",
  "car.cocHelp": "Für viele europäische Fahrzeuge, die neu nach Korea oder Japan exportiert wurden, ist weiterhin ein COC erhältlich. Es ersetzt die Einzelabnahme und senkt die Homologationskosten deutlich.",
  "car.confidence.placeholder": "Richtwert",
  "car.confidence.placeholderHelp": "Unverbindliche Richtwerte — Angaben werden noch geprüft",
  "car.confidence.estimate": "Schätzung",
  "car.confidence.estimateHelp": "Schätzung — die meisten Angaben sind geprüft",
  "car.confidence.researched": "Recherchiert",
  "car.confidence.researchedHelp": "Recherchierte, unverbindliche Richtwerte",
  "auctions.title": "Japanische Auktionen",
  "auctions.sub": "In Japan werden jede Woche rund 30 000 Autos versteigert. Wir bieten in Ihrem Auftrag, nachdem wir das Auktionsblatt gelesen und übersetzt haben.",
  "auctions.upcoming": "Anstehende Lose",
  "auctions.resultsTitle": "Was diese Autos tatsächlich erzielen",
  "auctions.resultsSub": "Zuschlagspreise aus jüngsten Verkäufen in Japan — {n} Ergebnisse über {models} Modelle, {from} bis {to}. Beschränkt auf die Marken, die wir importieren.",
  "auctions.resultsModel": "Modell",
  "auctions.resultsSales": "Verkäufe",
  "auctions.resultsMedian": "Median-Zuschlag",
  "auctions.grades": "Auktionsnoten verstehen",
  "auctions.gradesSub": "Jedes Fahrzeug wird vor dem Verkauf vom Auktionshaus geprüft und bewertet. Die Zustandsnote ist die wichtigste Zahl auf dem Auktionsblatt.",
  "auctions.grade": "Note",
  "auctions.interior": "Innenraum",
  "auctions.lot": "Los",
  "auctions.house": "Auktionshaus",
  "auctions.saleDate": "Auktionsdatum",
  "auctions.estimate": "Geschätzter Zuschlagspreis",
  "auctions.bidCta": "Gebotsauftrag anfragen",
  "auctions.notConfigured": "Die Live-Auktionsdaten sind noch nicht angebunden. Die folgenden Lose sind repräsentative Beispiele für Fahrzeuge, auf die wir bieten.",
  "enq.w.gradeMin": "Mindest-Auktionsnote",
  "enq.w.gradeMinHelp": "Das Urteil des Prüfers über das Fahrzeug. 4 und höher ist die übliche Grenze beim Import.",
  "enq.w.maxHammer": "Maximaler Zuschlagspreis (JPY)",
  "enq.w.maxHammerHelp": "Was wir nicht überbieten dürfen. Alles danach — Export, Fracht, Zoll, Homologation — kalkulieren wir vor Ihrer Zusage.",
  "auctions.bidTitle": "Wir bieten für Sie",
  "auctions.bidSub": "Nennen Sie uns das Fahrzeug und Ihre Obergrenze. Wir gehen die Hallen jede Woche durch, lesen und übersetzen den Prüfbericht und melden uns mit den Losen, die ein Gebot wert sind, samt Endpreis in Ihrem Land — bevor geboten wird.",
  "auctions.bidNote": "Rund 30 000 Fahrzeuge werden wöchentlich versteigert, ein Los steht nur Minuten auf dem Schirm. Ein Dauerauftrag ist die Art, so zu kaufen.",
  "auctions.samplesTitle": "So sieht ein kalkuliertes Los aus",
  "market.title": "Auf japanischen Auktionen",
  "market.headline": "Ein vergleichbarer {what} wird bei rund {amount} zugeschlagen, über {n} Verkäufe.",
  "market.spread": "Die Hälfte lag zwischen {band}.",
  "market.unsold": "{n} von {total} erreichten den Mindestpreis nicht.",
  "market.unsold.one": "1 von {total} erreichte den Mindestpreis nicht.",
  "market.basis": "Nur der Zuschlagspreis — ohne Auktionsgebühren, Export, Fracht, Zoll, MwSt. und Homologation. Großhandelsniveau, daher der Abstand zum Endpreis oben. Daten Dritter; wir waren bei diesen Verkäufen nicht zugegen.",
  "market.period": "Verkäufe vom {from} bis {to}.",
  "market.scope.model": "{what}, alle Modelljahre",
  "market.scope.years": "{what} von {from}–{to}",
  "auctions.sheetMarks": "Kürzel auf dem Auktionsblatt",
  "calc.title": "Importrechner",
  "calc.sub": "Sie haben bereits ein Fahrzeug gefunden? Geben Sie den Preis ein. Wir zeigen Ihnen die geschätzten Kosten inklusive Lieferung, Homologation und Zulassung.",
  "calc.price": "Preis im Herkunftsmarkt",
  "calc.origin": "Standortland des Fahrzeugs",
  "calc.destination": "Ihr Land",
  "calc.weight": "Leergewicht (kg)",
  "calc.co2": "CO₂ (g/km, WLTP)",
  "calc.cc": "Hubraum (cm³)",
  "calc.year": "Jahr",
  "calc.compute": "Berechnen",
  "calc.co2Help": "Frankreich erhebt hohe CO₂-Abgaben. Ohne diesen Wert lässt sich der CO₂-Malus nicht in die Schätzung einrechnen. Er kann den Fahrzeugpreis übersteigen.",
  "calc.weightHelp": "Bestimmt den französischen Gewichtsmalus und den Schweizer Einfuhrzoll.",
  "how.title": "Ablauf",
  "how.s1.title": "Sie wählen das Fahrzeug",
  "how.s1.body": "Sehen Sie sich den aktuellen Bestand aus Korea und Japan an oder sagen Sie uns, was Sie suchen. Wir finden es, auch unter Fahrzeugen, die nie öffentlich inseriert werden.",
  "how.s2.title": "Wir prüfen es",
  "how.s2.body": "Eine unabhängige Prüfung vor Ort, bevor Geld fliesst. Bei Auktionslosen lesen und übersetzen wir zuerst das Auktionsblatt.",
  "how.s3.title": "Wir kaufen und verschiffen",
  "how.s3.body": "Kauf, Abmeldung für den Export, Landtransport und Seefracht bis zu einem europäischen Hafen, mit umfassendem Versicherungsschutz.",
  "how.s4.title": "Zoll und Homologation",
  "how.s4.body": "Einfuhrzoll, Einfuhrsteuer (MWST), Einzelabnahme oder Verfahren mit COC für Ihr Land sowie alle Umbauten, die das Fahrzeug für die Strassenzulassung benötigt.",
  "how.s5.title": "Zugelassen und geliefert",
  "how.s5.body": "Auf Ihren Namen zugelassen, mit Kontrollschildern versehen und fahrbereit vor Ihre Haustür geliefert.",
  "how.homologation": "Homologation nach Land",
  "how.homologationSub": "Das Verfahren zur Strassenzulassung unterscheidet sich je nach Land. Gerade hier machen die meisten Importeure Fehler.",
  "how.route": "Verfahren",
  "how.cost": "Übliche Kosten",
  "how.leadTime": "Lieferfrist",
  "how.noCoc": "Ohne EU-Übereinstimmungsbescheinigung (COC)",
  "how.withCoc": "Mit EU-Übereinstimmungsbescheinigung (COC)",
  "how.vat": "Einfuhrsteuer (MWST)",
  "how.duty": "Einfuhrzoll",
  "enq.title": "Anfrage",
  "enq.name": "Name",
  "enq.email": "E-Mail",
  "enq.phone": "Telefon",
  "enq.country": "Lieferland",
  "enq.message": "Was wir wissen sollten",
  "enq.messagePlaceholder": "Zeitrahmen, Budget, Ausstattung, Eintausch…",
  "enq.submit": "Anfrage senden",
  "enq.sending": "Wird gesendet…",
  "enq.success": "Anfrage eingegangen",
  "enq.successBody": "Ihre Referenz lautet {ref}. Wir melden uns innerhalb eines Arbeitstags mit einer verbindlichen Offerte bei Ihnen.",
  "enq.error": "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie an contact@apexcars.ch.",
  "enq.wanted": "Sagen Sie uns, was Sie suchen",
  "enq.wantedSub": "Die meisten Fahrzeuge, die wir verkaufen, werden nie öffentlich inseriert. Beschreiben Sie das Fahrzeug. Wir suchen es.",
  "enq.w.make": "Marke",
  "enq.w.model": "Modell",
  "enq.w.yearFrom": "Jahr ab",
  "enq.w.yearTo": "Jahr bis",
  "enq.w.budget": "Budget (EUR)",
  "enq.w.mileage": "Laufleistung max. (km)",
  "enq.w.colour": "Farbe",
  "enq.w.notes": "Ausstattung, Optionen, unverzichtbare Kriterien",
  "enq.consent": "Wir verwenden Ihre Angaben ausschliesslich zur Beantwortung dieser Anfrage.",
  "footer.tagline": "Die Suche treibt uns an.",
  "footer.rights": "Alle Rechte vorbehalten.",
  "footer.disclaimer": "Die angezeigten Preise sind Schätzungen auf Grundlage der veröffentlichten Zoll-, Mehrwertsteuer- und Homologationsvorschriften. Sie stellen keine Offerte dar. Eine verbindliche Offerte erfolgt nach Prüfung des Fahrzeugs und Bestätigung seiner Dokumentation.",
  "market.encar": "Südkorea",
  "market.goonet": "Japan",
  "market.jpauction": "Auktionen in Japan",
  "common.noPhoto": "Keine Fotos verfügbar",
  "common.previous": "Zurück",
  "common.next": "Weiter",
  "common.photo": "Foto {n}",
  "common.language": "Sprache",
  "common.menu": "Menü",
  "common.currency": "Währung",
  "stock.sourcePrice": "Inseratspreis in EUR",
  "car.noRepair": "Keine Reparaturen gemeldet",
  "car.repair": "Reparaturen gemeldet",
  "car.origin": "Präferenzursprung",
  "home.stat.days": "Durchschnittliche Inseratsdauer",
};
